export const PackagesId = {
    BASIC: "Basic",
    STARTER: "Explorer",
    PROFESSIONAL: "Professional",
    CI: "CompetitiveIntelligence",
    AEO_CI_SEO: "AEOCompetitiveIntelligenceSEO",
    ADS_CI_SEO_AEO: "ADsCompetitiveIntelligenceSEOAEO",
    CI_SEO: "CompetitiveIntelligenceSEO",
    AEO: "AEOIntelligence",
    CUSTOM: "Custom",

    SI_BASIC: "basic",
    SI_INDIVIDUAL: "PremiumSalesExtension",
    SI_BUSINESS: "business",
    SI_ENTERPRISE: "enterprise",
} as const;

export type PackagesIdType = (typeof PackagesId)[keyof typeof PackagesId];
